import { render, staticRenderFns } from "./Uslugi.vue?vue&type=template&id=54983830&scoped=true&"
import script from "./Uslugi.vue?vue&type=script&lang=js&"
export * from "./Uslugi.vue?vue&type=script&lang=js&"
import style0 from "./Uslugi.vue?vue&type=style&index=0&id=54983830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54983830",
  null
  
)

export default component.exports